/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDbSystem = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 2h6v6h-2v1h2v2h1V9h6v6h-6v-2h-1v2h-2v3h3v-2h6v6h-6v-2h-5v-5H9v-2H8v2H6v1h2v6H2v-6h2v-1H2V9h6v2h1V9h2V8H9zm4 4V4h-2v2zm-2 5v2h2v-2zm-5 2v-2H4v2zm0 5H4v2h2zm12 0v2h2v-2zm0-7v2h2v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDbSystem as DbSystem };
